import { Grid, Typography } from "@mui/material";
import React from "react";
import { setWordCase } from "../../../assets/library";

const Personal = (props: any) => {
  const data = [
    {
      key: "First Name",
      label: props?.data?.firstName,
    },
    {
      key: "Last Name",
      label: props?.data?.lastName,
    },
    {
      key: "Gender",
      label: setWordCase(props?.data?.personalDetails?.Gender),
    },
    {
      key: "Nationality",
      label: setWordCase(props?.data?.personalDetails?.nationality),
    },
    {
      key: "Marital Status",
      label: setWordCase(props?.data?.personalDetails?.maritalStatus),
    },
    {
      key: "Do you have a valid Passport",
      label: setWordCase(props?.data?.personalDetails?.validPassport),
    },
    // {
    //   key: "First language",
    //   label: props?.data?.personalDetails?.validPassport,
    // },
    {
      key: "Do you have a valid study /work permit",
      label: setWordCase(props?.data?.personalDetails?.validPermit),
    },
    {
      key: "Have you been refused a visa from CAN, UK, US, AUS, NZ",
      label: props?.data?.personalDetails?.visaRejectedDetails,
    },
  ];
  const address = [
    {
      key: "Country",
      label: props?.data?.personalDetails?.temporaryAddress?.country?props?.data?.personalDetails?.temporaryAddress?.country:"N/A",
    },
    {
      key: "State / Province ",
      label: props?.data?.personalDetails?.temporaryAddress?.state ?props?.data?.personalDetails?.temporaryAddress?.state:"N/A",
    },
    {
      key: "City / Town",
      label: props?.data?.personalDetails?.temporaryAddress?.city ?props?.data?.personalDetails?.temporaryAddress?.city:"N/A",
    },
    {
      key: "Zip Code",
      label: props?.data?.personalDetails?.temporaryAddress?.pinCode? props?.data?.personalDetails?.temporaryAddress?.pinCode:"N/A",
    },
    {
      key: "Is your home address same as Contact address",
      label: props?.data?.personalDetails?.temporaryAddress ? (props?.data?.personalDetails?.temporaryAddress === props?.data?.personalDetails?.permanentAddress ? "Yes":"No") : "N/A",
    },
    {
      key: "Address",
      label: props?.data?.personalDetails?.temporaryAddress?props?.data?.personalDetails?.temporaryAddress?.addressLine1 + ","+props?.data?.personalDetails?.temporaryAddress?.addressLine2:"N/A"

    },
  ];
  return (
    <div>
      <Typography sx={{background:"#FCF1EE",width:"fit-content",p:1,borderRadius:"10px",mb:2}}>Personal Information</Typography>
      <Grid container sx={{ boxShadow: 3, p: 2, borderRadius: "10px" }}>
        {data?.map((item,i) => (
          <Grid item xs={6} sx={{ display: "flex", p: 1 }} key={i}>
            <Grid container>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    minWidth: 150,
                    color: "#7C7A7A",
                    fontSize: "14px",
                  }}
                >
                  {item.key}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>{item.label}</Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Typography sx={{background:"#FCF1EE",width:"fit-content",p:1,borderRadius:"10px",my:2}}>Contact Address</Typography>
      <Grid container sx={{ boxShadow: 3, p: 2, borderRadius: "10px" }}>
        {address?.map((item,i) => (
          <Grid item xs={6} sx={{ display: "flex", p: 1 }} key={i}>
            <Grid container>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    minWidth: 150,
                    color: "#7C7A7A",
                    fontSize: "14px",
                  }}
                >
                  {item.key}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>{item.label}</Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Personal;
